<script setup lang="ts">
import ToastContainer from '@/components/ToastContainer.vue'
import CookieConsent from '@/components/shared/CookieConsent.vue'
</script>

<template>
  <router-view />
  <ToastContainer />
  <CookieConsent />
</template>
